import { Label } from '@radix-ui/react-dropdown-menu';
import { TextBoxEditorTitle } from '../../Typography';

type MultiDropdownLabelProps = { label: string };

export const MultiDropdownFilterLabel = ({
  label,
}: MultiDropdownLabelProps) => (
  <Label>
    <div className="bg-ds-natural-100 p-2">
      <TextBoxEditorTitle label={label.toUpperCase()} />
    </div>
  </Label>
);
